import axios from 'axios';
import qs from 'qs';
import store from '@/store'
import router from '../router';
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.API_BASE,
  timeout: 15000,
  transformRequest: [function (data) {
    return qs.stringify({...data});
  }]
});


// 前置拦截器
service.interceptors.request.use(
    config => {
      // if (store.getters.token) {
      //   config.headers['X-Token'] = getToken()
      // }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
);

// 后置拦截器
service.interceptors.response.use(
    response => {
      const res = response.data

      if (response.data.code != 1) {
        if (response.data.code === '200001') {
          router.push({name: 'Login'});
        }
        Message({message: response.data.message, type: 'error'});
        return Promise.reject(res.message || 'error')
      } else {
        return Promise.resolve(response)
      }
    },
    error => {
      console.log('err' + error) // for debug
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
);

// get请求
const get = (url, args) => {
  return service({
    url,
    method: 'get',
    params: args
  })
      .then((response) => {
        return response.data;
      })
};

// post请求
const post = (url, args) => {
  return service({
    url,
    method: 'post',
    data: args
  })
      .then((response) => {
        return response.data;
      })
};

export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/utils/request.js